'use client';
import { useEffect, useState } from 'react';
const MOBILE_BREAKPOINT = 1280;
/**
 * Hook to check if the screen is mobile
 * @example
 * ```ts
 * import { useIsMobile } from "@cloud/shared/ui"
 *
 * const isMobile = useIsMobile()
 * ```
 */
export function useIsMobile() {
    const [isMobile, setIsMobile] = useState(undefined);
    useEffect(() => {
        const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
        const onChange = () => {
            setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
        };
        mql.addEventListener('change', onChange);
        setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
        return () => mql.removeEventListener('change', onChange);
    }, []);
    return !!isMobile;
}
